import React from 'react';

interface Props {
  data: any;
}

function PickUpInfo({ data }: Props) {
  return (
    <div>
      <div className='row'>
        <div className='col-sm-6 col-md-12 col-md-12'>
          <p className='boldglobaltext mb-0'>Pickup Time</p>
        </div>
        <div className='col-sm-6 col-md-12'>
          <input
            type='text'
            className='global-text-16 w-100  p-2 pickup-disableInput'
            value={`Between: ${data?.min_start_time} to ${data?.max_start_time}.`}
            disabled
          />
        </div>
      </div>

      <div className='row mt-4'>
        <div className='col-sm-6 col-md-12 col-md-12'>
          <p className='boldglobaltext mb-0'>Close Time</p>
        </div>
        <div className='col-sm-6 col-md-12'>
          <input
            type='text'
            className='global-text-16 w-100 p-2 pickup-disableInput'
            value={`Between: ${data?.min_end_time} to ${data?.max_end_time}.`}
            disabled
          />
        </div>
      </div>

      <div className='row mt-4'>
        <div className='col-sm-6 col-md-12 col-md-12'>
          <p className='boldglobaltext mb-0'>Pickup Window</p>
        </div>
        <div className='col-sm-6 col-md-12'>
          <input
            type='text'
            className='global-text-16 w-100 p-2 pickup-disableInput'
            value={`Minimum ${data?.pickup_window} Hours`}
            disabled
          />
        </div>
      </div>

      <div className='row mt-4'>
        <div className='col-sm-6 col-md-12 col-md-12'>
          <p className='boldglobaltext mb-0'>Max future day pickup</p>
        </div>
        <div className='col-sm-6 col-md-12'>
          <input
            type='text'
            className='global-text-16 w-100 p-2 pickup-disableInput'
            value={`${data?.max_pickup_days} days.`}
            disabled
          />
        </div>
      </div>

      <div className='row mt-4'>
        <div className='col-sm-6 col-md-12 col-md-12'>
          <p className='boldglobaltext mb-0'>Sameday Pickup Cutoff</p>
        </div>
        <div className='col-sm-6 col-md-12'>
          <input
            type='text'
            className='global-text-16 w-100 p-2 pickup-disableInput'
            value={data?.min_time_same_day}
            disabled
          />
        </div>
      </div>
    </div>
  );
}

export default PickUpInfo;
